<template>
	<v-layout row wrap>
		<v-flex v-for="(field, index) in schema" :key="index" v-bind="field.cols">
			<component
				:is="field.items ? 'VSelect' : 'VTextField'"
				v-if="field.model"
				class="mb-3 mt-2"
				v-bind="{ ...baseProps, ...field }"
				:value="getValue(root, field.model)"
				v-on="field.listeners"
				@input="setValue(root, field.model, $event)"
			/>
			<component
				:is="field.items ? 'VSelect' : 'VTextField'"
				v-else
				v-bind="{ ...baseProps, ...field }"
				:value="field.value"
				v-on="field.listeners"
			/>
		</v-flex>
	</v-layout>
</template>

<script>
	import { VTextField } from 'vuetify/lib';
	import VSelect from './selectFixed';

	export default {
		name: 'FormCreator',

		components: { VTextField, VSelect },

		props: {
			baseProps: {
				default() {
					return {
						// box: true,
						backgroundColor: '#ffffff',
						itemText: 'descricao',
						itemValue: 'id',
						returnObject: true,
						smallChips: true,
						validateOnBlur: true
					};
				}
			},
			root: { required: true },
			schema: {
				required: true,
				type: Array
			}
		},

		methods: {
			getValue(obj, parts) {
				if (!parts) {
					return;
				}

				parts = Array.isArray(parts) ? parts : parts.split('.');

				const part = parts.shift();

				if (!obj[part] || !parts.length) {
					return obj[part];
				}

				return this.getValue(obj[part], parts);
			},

			setValue(obj, parts, value) {
				if (!parts) {
					return;
				}

				parts = Array.isArray(parts) ? parts : parts.split('.');

				const part = parts.shift();

				if (!obj[part]) {
					this.$set(obj, part, {});
				}

				if (!parts.length) {
					if (value && typeof value === 'object' && !Array.isArray(value)) {
						obj[part] = { ...obj[part], ...value };
					} else {
						obj[part] = value;
					}

					return;
				}

				this.setValue(obj[part], parts, value);
			}
		}
	};
</script>